import { Column } from "../../robots/components/v2/_type";

export const columns: Column[] = [
  { id: "map_name_display", label: "Name" },
  { id: "map_level", label: "Level" },
  { id: "building", label: "Building" },
  { id: "preview", label: "Preview" },
  { id: "action", label: "Action" }
];

export const fuseOptions = {
  keys: ["building", "map_name_display", "map_name", "map_uuid", "map_level"],
  includeScore: true
}